<template>
  <div class="painel col-12">
    <div class="container p-5">
      <TituloDuplo v-if="titulo != undefined && tipoTitulo == 'duplo'" :theme="theme" :titulo="titulo" class="mb-5" />
      <titulo-grande v-if="titulo != undefined && tipoTitulo == 'grande'" :corFundo="bg" :texto="titulo" />
      <div id="slot-text" class="py-5 px-3">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import TituloDuplo from './TituloDuplo.vue';
import TituloGrande from './TituloGrande.vue';

export default {
  name: "PainelBase",
  components: {
    TituloDuplo,
    TituloGrande
  },
  props: {
    titulo: String,
    tipoTitulo: {
      default: 'duplo'
    },
    bgAtivo: {
      default: true
    },
    theme: {
      default: 'dark'
    }
  },
  data() {
    return {
      bg: '',
      cor: '',
      bordertop: '',
    }
  },
  mounted() {
    switch (this.theme) {
      case 'dark':
        this.bg = `var(--cor-fundo-base)`;
        this.cor = `#FFF`;
        this.bordertop = '';
        break;
      case 'light':
        this.bg = `#FFF`;
        this.cor = `var(--cor-fundo-base)`;
        this.bordertop = '';
        break;

      default:
        this.bg = ``;
        this.cor = `#FFF`;
        this.bordertop = '';
        break;
    }

    if (this.bgAtivo) {
      this.bg = this.bg
    } else {
      this.bg = '';
    }
  },
};
</script>

<style scoped>
#slot-text {
  font-family: 'Poppins, sans-serif' !important;
  font-size: 18px !important;
  word-spacing: 8px;
}

.painel {
  border-top: 3px solid var(--cor-base-texto);
  background-color: v-bind('bg');
  color: v-bind(cor);
  border-top: 3px 0 3px solid var(--cor-base-texto);
}
</style>